"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prefixFeatureFlags = void 0;
/**
 * Converts from `{ 'some-flag': 'enabled', 'other-flag': 'disabled' }`
 * to `{ 'flags.some-flag': 'enabled', 'flags.other-flag': 'disabled' }`
 *
 * Reason for doing it is that when all user properties are tied to a user, the feature flags
 * should be distinct from other user properties, like:
 * ```
 * {
 *   'some-property': 'some-value'
 *   'other-property': 'other-value'
 *   'flags.some-flag': 'enabled'
 * }
 * ```
 */
function prefixFeatureFlags(featureFlags) {
    return Object.keys(featureFlags).reduce(function (flags, flag) {
        var _a;
        return (__assign(__assign({}, flags), (_a = {}, _a["flags.".concat(flag)] = featureFlags[flag], _a)));
    }, {});
}
exports.prefixFeatureFlags = prefixFeatureFlags;
//# sourceMappingURL=prefixFeatureFlags.js.map